export enum RespondentType {
  entity = 'Entity',
  person = 'Person',
}
